export const TELEOPERATOR_PROFESSION_SLUGS = ['employe-centre-dappel-hf'];

export interface QualificationHttp {
  type: 'qualification_repositories';
  id: string;
  attributes: {
    label: string;
    code: string;
  };
}

export interface Qualification {
  id: string;
  label: string;
  code: string;
  isTeleoperator: boolean;
}

export interface QualificationWizard {
  type: 'qualification_repositories';
  id: string;
  attributes: {
    label: string;
    code: string;
  };
}
